/**
 * Chat8DebugButton - Button to open WebSocket debug modal
 * Only visible in development environment
 */

import React from "react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Terminal } from "lucide-react";

interface Chat8DebugButtonProps {
  onClick: () => void;
  className?: string;
  variant?: "default" | "outline" | "ghost";
  size?: "default" | "sm" | "lg" | "icon";
}

export const Chat8DebugButton = React.forwardRef<
  HTMLButtonElement,
  Chat8DebugButtonProps
>(({
  onClick,
  className = "",
  variant = "outline",
  size = "sm"
}, ref) => {
  // Do not show in production
  if (process.env.NODE_ENV === 'production') {
      return null;
  }

  return (
    <Button
      ref={ref}
      variant={variant}
      size={size}
      onClick={onClick}
      className={`bg-navy-700 border-navy text-platinum hover:bg-navy-600 relative ${className}`}
      aria-label="Abrir ferramentas de debug WebSocket"
      title="Ferramentas de Debug WebSocket"
    >
      <Terminal className="h-4 w-4 mr-1.5" />
      <span className="text-xs font-semibold">DEBUG</span>
      <Badge 
        variant="secondary" 
        className="ml-1.5 px-1.5 py-0 text-[10px] bg-amber-500/20 text-amber-300 border-amber-500/30"
      >
        DEV
      </Badge>
    </Button>
  );
});

Chat8DebugButton.displayName = 'Chat8DebugButton';
